import { render, staticRenderFns } from "./DepartedTripsToday.vue?vue&type=template&id=eca0b72e"
import script from "./DepartedTripsToday.vue?vue&type=script&lang=js"
export * from "./DepartedTripsToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports